<div fxLayout="row" class="header">
  <div class="header_label" fxFlex>Su</div>
  <div class="header_label" fxFlex>M</div>
  <div class="header_label" fxFlex>T</div>
  <div class="header_label" fxFlex>W</div>
  <div class="header_label" fxFlex>Th</div>
  <div class="header_label" fxFlex>F</div>
  <div class="header_label" fxFlex>S</div>
</div>
<mat-divider></mat-divider>
<div fxLayout="column" class="calendar" [ngClass]="{ 'calendar--scrollable': !monthView }">
  <div *ngFor="let week of weeks" fxLayout="row" class="week">
    <div
      *ngFor="let day of week.days"
      fxFlex
      fxLayoutAlign="center center"
      class="day"
      [ngClass]="{ 'day--different-month': !day.isInPlan, 'day--selectable': hasAnyWorkout(day) }"
    >
      <div class="day_anchor" (mouseover)="hover(day, $event)" (mousedown)="beginDrag(day)" (mouseup)="endDrag(day)"></div>

      <div class="day_selected" *ngIf="selectedDay === day"></div>
      <span class="day_number">{{ day.number }}</span>
      <span class="day_month-label" *ngIf="day.monthLabel">{{ day.monthLabel }}</span>

      <span *ngIf="hasWorkout(day)" class="day_workout-icon" [ngClass]="{ 'day_workout-icon--complete': day.complete }">
        {{ getWorkoutIcon(day) }}
      </span>

      <mat-spinner diameter="25" class="day_spinner-marker" *ngIf="day.copyingInProgress"></mat-spinner>

      <mat-checkbox
        class="day_multi-select"
        *ngIf="copying && hasNoWorkout(day)"
        [(ngModel)]="selectedDays[day.date.toDate()]"
      ></mat-checkbox>

      <button
        mat-icon-button
        *ngIf="canEdit && isHovering(day) && hasNoWorkout(day) && !copying"
        class="day_add-workout"
        [matMenuTriggerFor]="focusMenu"
      >
        <mat-icon>add</mat-icon>
      </button>

      <div *ngIf="hasPhase(day)" class="day_phase-label" [ngClass]="phaseColorClass(day.phase)" (click)="editPhase(day)">
        {{ phaseName(day) }}
      </div>
      <div *ngIf="day.isHighlighted" class="day_highlight"></div>

      <div *ngIf="hasRestrictedWorkout(day)" class="day_restrict-label">
        <mat-icon>clear</mat-icon>
        <span class="day_restrict-label_label">{{ day.workout.name }}</span>
      </div>

      <mat-menu #focusMenu="matMenu">
        <button mat-menu-item color="primary" (click)="addCustomWorkout(day)">Custom…</button>
        <button mat-menu-item color="primary" (click)="addWorkoutFromLibrary(day)">From Library…</button>
        <button *ngFor="let workout of sortedWorkoutTypes" mat-menu-item (click)="addWorkout(day, workout)">
          {{ workout.name }}
        </button>
        <button mat-menu-item (click)="addRestrictedWorkout(day)">Other</button>
      </mat-menu>

      <div class="day_percentRM" *ngIf="hasPercent1RM(day)">{{ day.percent1RM }}%1RM</div>
    </div>
  </div>
</div>
